import styled from 'styled-components';
import { Base as NavbarButtonBase } from '../NavbarButton/styles';

// $hasLabel relaxes the fixed-width constraint when the button carries text.
// Icon-only buttons stay 40px (uniform toolbar grid); labeled buttons fit content.
export const Base = styled(NavbarButtonBase)<{ $hasLabel?: boolean }>`
	${({ $hasLabel }) =>
		$hasLabel
			? `
				width: auto;
				padding: 4px 10px;
				gap: 6px;
			`
			: `width: 40px;`}
`;

export const Label = styled.span`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

